import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatUser as createUserApi,
    updateUser as updateUserApi,
    getAllUser as getAllUserApi,
    getUser as getUserApi,
    getUserHits as getUserHitsApi,
    getUserBasicRoles as getUserBasicRolesApi,
} from './api';

// actions
import { userApiResponseSuccess, userApiResponseError } from './actions';

// constants
import { UserActionTypes } from './constants';

type UserData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add User
 * @param {*} payload
 */
function* AddUser({ payload, type }: UserData): SagaIterator {
    try {
        const response = yield call(createUserApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                userApiResponseSuccess(UserActionTypes.ADD_USER, data, 'User has been created.', code, false, true)
            );
        } else {
            let msg = `An error while creating User!`;
            if (message) msg = message;
            yield put(userApiResponseSuccess(UserActionTypes.ADD_USER, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(userApiResponseError(UserActionTypes.ADD_USER, [], error, 404, true, false));
    }
}

/**
 * Edit User
 * @param {*} payload
 */
function* EditUser({ payload, type }: UserData): SagaIterator {
    try {
        const response = yield call(updateUserApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                userApiResponseSuccess(
                    UserActionTypes.EDIT_USER,
                    data,
                    'User Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit User!`;
            if (message) msg = message;
            yield put(userApiResponseSuccess(UserActionTypes.EDIT_USER, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(userApiResponseError(UserActionTypes.EDIT_USER, [], error, 404, true, false));
    }
}

/**
 * Fetch User
 * @param {*} payload
 */
function* GetUser({ payload, type }: UserData): SagaIterator {
    try {
        const response = yield call(getUserApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(userApiResponseSuccess(UserActionTypes.GET_USER, data, message, code, false, false));
        } else {
            let msg = `An error while getting User!`;
            if (message) msg = message;
            yield put(userApiResponseSuccess(UserActionTypes.GET_USER, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(userApiResponseError(UserActionTypes.GET_USER, [], error, 404, true, false));
    }
}

/**
 * Fetch User Basic Roles
 * @param {*} payload
 */
function* GetUserBasicRoles({ payload, type }: UserData): SagaIterator {
    try {
        const response = yield call(getUserBasicRolesApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(userApiResponseSuccess(UserActionTypes.GET_USER_BASIC_ROLES, data, message, code, false, false));
        } else {
            let msg = `An error while getting User Roles!`;
            if (message) msg = message;
            yield put(userApiResponseSuccess(UserActionTypes.GET_USER_BASIC_ROLES, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(userApiResponseError(UserActionTypes.GET_USER_BASIC_ROLES, [], error, 404, true, false));
    }
}

/**
 * Fetch Users
 * @param {*} payload
 */
function* GetUsers({ payload, type }: UserData): SagaIterator {
    try {
        const response = yield call(getAllUserApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(userApiResponseSuccess(UserActionTypes.GET_USERS, responseData, message, code, false, false));
        } else {
            let msg = `An error while getting User Listing!`;
            if (message) msg = message;
            yield put(userApiResponseSuccess(UserActionTypes.GET_USERS, responseData, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(userApiResponseError(UserActionTypes.GET_USERS, [], error, 404, true, false));
    }
}

/**
 * Fetch User Capture Hits
 * @param {*} payload
 */
function* GetUserHits({ payload, type }: UserData): SagaIterator {
    try {
        const response = yield call(getUserHitsApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(userApiResponseSuccess(UserActionTypes.CAPTURE_USER_HITS, data, message, code, false, false));
        } else {
            let msg = `An error while getting User Capture Hits!`;
            if (message) msg = message;
            yield put(userApiResponseSuccess(UserActionTypes.CAPTURE_USER_HITS, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(userApiResponseError(UserActionTypes.CAPTURE_USER_HITS, [], error, 404, true, false));
    }
}

export function* watchGetUser() {
    yield takeEvery(UserActionTypes.GET_USER, GetUser);
}

export function* watchGetUsers() {
    yield takeEvery(UserActionTypes.GET_USERS, GetUsers);
}

export function* watchAddUser() {
    yield takeEvery(UserActionTypes.ADD_USER, AddUser);
}

export function* watchEditUser(): any {
    yield takeEvery(UserActionTypes.EDIT_USER, EditUser);
}

export function* watchGetUserHits(): any {
    yield takeEvery(UserActionTypes.CAPTURE_USER_HITS, GetUserHits);
}

export function* watchGetUserBasicRoles(): any {
    yield takeEvery(UserActionTypes.GET_USER_BASIC_ROLES, GetUserBasicRoles);
}

function* userSaga() {
    yield all([
        fork(watchGetUser),
        fork(watchAddUser),
        fork(watchEditUser),
        fork(watchGetUsers),
        fork(watchGetUserHits),
        fork(watchGetUserBasicRoles),
    ]);
}

export default userSaga;
